import { InjectionToken } from '@angular/core';

/**
 * This token indicates whether the application is running in (unit) tests or not.
 * The default value is false. In test.ts it is overridden to true.
 */
export const runningInTestsToken = new InjectionToken<boolean>('runningInTests', {
  providedIn: 'root',
  factory: () => false,
});
